import React, { useContext } from "react";
import Textarea from "@mui/joy/Textarea";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Sheet from "@mui/joy/Sheet";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import SendIcon from "@mui/icons-material/Send";
import { ChatContext } from "../mensajecontext";
import { height } from "@mui/system";

export default function CajaTextoGrupal() {
  const { recibirMensajeGrupal, enviarMensajeGrupal, mensaje_grupal } =
    useContext(ChatContext);

  return (
    <Box>
      <Textarea
        minRows={5}
        value={mensaje_grupal.mensaje}
        variant="outlined"
        color="neutral"
        onChange={(value) => {
          recibirMensajeGrupal(value.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            enviarMensajeGrupal();
          }
        }}
        sx={{ maxHeight: 150 }}
        endDecorator={
          <Box
            sx={{
              display: "flex",
              gap: "var(--Textarea-paddingBlock)",
              pt: "var(--Textarea-paddingBlock)",
              borderTop: "1px solid",
              borderColor: "divider",
              flex: "auto",
            }}
          >
            <Button
              sx={{ ml: "auto" }}
              variant="soft"
              color="neutral"
              size="sm"
              endDecorator={<SendIcon />}
              onClick={() => {
                enviarMensajeGrupal();
              }}
            >
              Enviar
            </Button>
          </Box>
        }
      />
    </Box>
  );
}
